import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dialog from 'components/ContextDialog';
import { getLiteral } from 'utils/getLiteral';
import { CrudActions } from 'actions';
import Button from 'components/Button';
import { CancelIcon } from 'components/icons';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import dialogStyles from './DeleteDialog_styles';
import { SALESORDERS, RATES } from 'constants/Entities';

const propTypes = {
    show: PropTypes.bool,
    error: PropTypes.bool,
    loading: PropTypes.bool,
    model: PropTypes.object,
    entityType: PropTypes.object,
    onShowDeleteCrud: PropTypes.func,
    onDeleteCrud: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    const { showDeleteCrud, deleteCrud } = bindActionCreators(CrudActions, dispatch);
    return {
        onShowDeleteCrud: showDeleteCrud,
        onDeleteCrud: deleteCrud,
    };
}

function mapStateToProps(state) {
    return state.crud.deleteEntity;
}

class DeleteDialog extends Component {
    onDeleteCrud = () => {
        let { onDeleteCrud, entityType, model } = this.props;
        onDeleteCrud(entityType, model.id);
    };

    onClose = () => {
        let { onShowDeleteCrud } = this.props;
        onShowDeleteCrud(undefined, undefined, false);
    };

    renderError = () => {
        return (
            <div>
                <Literal style={dialogStyles.title_text2} literal="error_an_error_occurred" />
                <Literal style={dialogStyles.text_medium} literal="error_generalerror" />
            </div>
        );
    };

    renderForm = () => {
        let { model, entityType } = this.props;
        let name;
        switch (entityType) {
            case SALESORDERS:
                name = model ? ` ${model.reference} ${model.salesOrderNumber}` : '';
                break;
            case RATES:
                name = model ? ` ${model.name}` : '';
                break;
            default:
                name = '';
                break;
        }
        return (
            <div style={dialogStyles.text_medium}>
                <Literal literal={'confirm_delete'} params={[name]} />
            </div>
        );
    };

    getTitleLiteralKey = () => {
        let { entityType } = this.props;
        switch (entityType) {
            case SALESORDERS:
                return 'action_delete_salesorder';
                break;
            case RATES:
                return 'action_delete_rate';
                break;
            default:
                return 'action_delete';
                break;
        }
    };

    render() {
        let { show, error } = this.props;

        if (!show) {
            return null;
        }
        const actions = [
            <Button text={getLiteral('action_cancel')} type="primary" onClick={this.onClose} />,
            <Button
                className="crud-modal__delete-button"
                text={getLiteral('action_delete')}
                onClick={this.onDeleteCrud}
            />,
        ];

        let renderContent = this.renderForm();
        let bodyStyle = error ? dialogStyles.contentStyleSmallError : {};
        let titleLiteralKey = this.getTitleLiteralKey();

        return (
            <Dialog
                title={
                    <div>
                        {getLiteral(titleLiteralKey)}
                        <CancelIcon onClick={this.onClose} style={dialogStyles.clearIcon} />
                    </div>
                }
                actions={actions}
                open={show}
                contentStyle={dialogStyles.contentStyleSmall}
                onRequestClose={this.onClose}
                bodyStyle={bodyStyle}
                titleStyle={dialogStyles.title}
                actionsContainerStyle={dialogStyles.actionsContainer}
            >
                <div>{renderContent}</div>
            </Dialog>
        );
    }
}

DeleteDialog.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);
